import React, { Component } from "react";
import SearchWarehouse from "../warehouses/searchWarehouse";
import SearchOutlet from "../../sales/outlets/searchOutlet";
import { TabView, TabPanel } from "primereact/tabview";
class SearchLocation extends Component {
  state = {
    activeIndex: 0,
    tabs: [],
  };
  componentDidMount() {
    const {
      allWarehouse = true,
      allOutlet = true,
      locationType = "",
    } = this.props;
    const tabsTmp = [];
    if (locationType === "Warehouses" || locationType === "") {
      tabsTmp.push({
        header: "Warehouses",
        icon: "fas fa-warehouse",
        component: (
          <SearchWarehouse
            allWarehouses={allWarehouse}
            onSelectWarehouse={this.handleSelectWarehouse}
          />
        ),
      });
    }
    if (locationType === "Outlets" || locationType === "") {
      tabsTmp.push({
        header: "Outlets",
        icon: "fas fa-store",
        component: (
          <SearchOutlet
            allOutlets={allOutlet}
            onSelectOutlet={this.handleSelectOutlet}
          />
        ),
      });
    }
    this.setState({ tabs: tabsTmp });
  }
  render() {
    const { tabs, activeIndex = 0 } = this.state;

    return (
      <div className="tabview">
        <div className="card">
          {tabs.length > 0 ? (
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => {
                this.setState({ activeIndex: e.index });
              }}
              className="tabview"
              scrollable
            >
              {tabs.map((item, index) => (
                <TabPanel
                  key={index}
                  header={item.header}
                  rightIcon={item.icon}
                >
                  {item.component}
                </TabPanel>
              ))}
            </TabView>
          ) : null}
        </div>
      </div>
    );
  }

  handleSelectOutlet = (outlet) => {
    const { onSelectLocation } = this.props;
    onSelectLocation(outlet.ID, outlet.outletName, "O");
  };

  handleSelectWarehouse = (warehouse) => {
    const { onSelectLocation } = this.props;
    onSelectLocation(warehouse.ID, warehouse.warehouseName, "W");
  };
}

export default SearchLocation;
